<template>
  <div class="home ignore" id="phWebHome">
    <div class="home-header-wrap" id="header">
      <div class="header-wrap">
        <span class="project-name">CaptarCash</span>
        <ul class="navs-wrap">
          <li class="nav-wrap">
            <a href="#home" class="nav">Portal</a>
          </li>
          <li class="nav-wrap">
            <a href="#product" class="nav">Producto</a>
          </li>
          <li class="nav-wrap">
            <a href="#faq" class="nav">FAQ</a>
          </li>
          <li class="nav-wrap">
            <a href="#aboutUs" class="nav">Sobre nosotros</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-content-wrap">
      <!--<div class="home-img">
                <div class="download-wrap">
                    <div class="download-btn-wrap">
                        <div class="icon-download"></div>
                        <span class="download-text">
                            Get the App
                        </span>
                    </div>
                </div>
      </div>-->
      <a name="home"></a>
      <div class="download-wrap">
        <div
          class="download-btn-wrap"
          id="phWebHomedownloadApp"
          @click="download"
        >
          <button class="download-button">
            DESCARGA  APP
          </button>
          <!-- <div class="icon-download"></div>
          <span class="download-text">Get the App</span>-->
        </div>
      </div>
      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide>
          <div class="home-img home-img1"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img home-img2"></div>
        </swiper-slide>
        <swiper-slide>
          <div class="home-img home-img3"></div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <ul class="home-content-detail-wrap">
        <li class="home-content-detail content-our-advantage-wrap">
          <div class="content-detail content-our-advantage">
            <div class="title">Nuestras ventajas</div>
            <ul class="advantage-list">
              <li class="advantage">
                <div class="advantage-detail-wrap">
                  <div class="advantage-icon-wrap">
                    <div class="advantage-icon advantage-icon1"></div>
                  </div>
                  <div class="advantage-detail">
                    <div class="advantage-title">Préstamo rápido</div>
                    <div class="advantage-text-wrap">
                      <p class="advantage-text">
                        En 8 minutos puedes aprobar tu solicitud.
                      </p>
                      <p class="advantage-text">
                        En 2 hora puedes tenerlo en tu propia cuenta.
                      </p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="advantage">
                <div class="advantage-detail-wrap">
                  <div class="advantage-icon-wrap">
                    <div class="advantage-icon advantage-icon3"></div>
                  </div>
                  <div class="advantage-detail">
                    <div class="advantage-title">
                      Experiencia en línea fluida
                    </div>
                    <div class="advantage-text-wrap">
                      <p class="advantage-text">
                        Sube tu ID/INE correctamente y termina tu solicitud en
                        línea, ¡sin papeleo¡
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li class="home-content-detail content-show-swipper-wrap">
          <a name="product"></a>
          <swiper :options="prodSwiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide>
              <div class="prod-wrap">
                <div class="product">
                  <div class="prod-desc">
                    <div class="prod-desc-title">
                      4 pasos fáciles para obtener dinero en 1 hora
                    </div>
                    <div class="prod-desc-text-wrap">
                      <p class="prod-desc-text active-text">
                        1.Regístrate con tu celuar android
                      </p>
                      <p class="prod-desc-text">
                        2.Valida tu información (ID/INE), no más papeleo.
                      </p>
                      <p class="prod-desc-text">3.Aprueba tu solicitud</p>
                      <p class="prod-desc-text">
                        4.Tu préstamo será depositado dentro de 1 hora
                        (dependiendo de la forma en que elijas recibirlo).
                      </p>
                    </div>
                  </div>
                  <div class="prod-img prod-img1"></div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prod-wrap">
                <div class="product">
                  <div class="prod-desc">
                    <div class="prod-desc-title">
                      4 pasos fáciles para obtener dinero en 1 hora
                    </div>
                    <div class="prod-desc-text-wrap">
                      <p class="prod-desc-text">
                        1.Regístrate con tu celuar android
                      </p>
                      <p class="prod-desc-text active-text">
                        2.Valida tu información (ID/INE), no más papeleo.
                      </p>
                      <p class="prod-desc-text">3.Aprueba tu solicitud</p>
                      <p class="prod-desc-text">
                        4.Tu préstamo será depositado dentro de 1 hora
                        (dependiendo de la forma en que elijas recibirlo).
                      </p>
                    </div>
                  </div>
                  <div class="prod-img prod-img2"></div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prod-wrap">
                <div class="product">
                  <div class="prod-desc">
                    <div class="prod-desc-title">
                      4 pasos fáciles para obtener dinero en 1 hora
                    </div>
                    <div class="prod-desc-text-wrap">
                      <p class="prod-desc-text">
                        1.Regístrate con tu celuar android
                      </p>
                      <p class="prod-desc-text">
                        2.Valida tu información (ID/INE), no más papeleo.
                      </p>
                      <p class="prod-desc-text active-text">
                        3.Aprueba tu solicitud
                      </p>
                      <p class="prod-desc-text">
                        4.Tu préstamo será depositado dentro de 1 hora
                        (dependiendo de la forma en que elijas recibirlo).
                      </p>
                    </div>
                  </div>
                  <div class="prod-img prod-img3"></div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="prod-wrap">
                <div class="product">
                  <div class="prod-desc">
                    <div class="prod-desc-title">
                      4 pasos fáciles para obtener dinero en 1 hora
                    </div>
                    <div class="prod-desc-text-wrap">
                      <p class="prod-desc-text">
                        1.Regístrate con tu celuar android
                      </p>
                      <p class="prod-desc-text">
                        2.Valida tu información (ID/INE), no más papeleo.
                      </p>
                      <p class="prod-desc-text">3.Aprueba tu solicitud</p>
                      <p class="prod-desc-text active-text">
                        4.Tu préstamo será depositado dentro de 1 hora
                        (dependiendo de la forma en que elijas recibirlo).
                      </p>
                    </div>
                  </div>
                  <div class="prod-img prod-img4"></div>
                </div>
              </div>
            </swiper-slide>

            <div class="prod-pagination" slot="pagination"></div>
          </swiper>
        </li>
        <li class="home-content-detail content-prod-decs-wrap">
          <ul class="content-prod-decs">
            <li class="prod-decs">
              <div class="prod-decs-img img-left prod-decs-img1"></div>
              <div class="decs-wrap decs-right">
                Descarga la APP Captarcash
                <br />Regístrate con tu celuar android y sube tu información
                personal (ID y información del trabajo).
              </div>
            </li>
            <li class="prod-decs">
              <div class="decs-wrap decs-left">
                Velificación automática en línea
                <br />Rápido que cualquiera otra plataforma de préstamos(130
                minutos).
              </div>
              <div class="prod-decs-img img-right prod-decs-img2"></div>
            </li>
            <li class="prod-decs">
              <div class="prod-decs-img img-left prod-decs-img3"></div>
              <div class="decs-wrap decs-right">
                Las comisiones totalmente transparente y descripción de los
                terminos y condiciones claramente
                <br />Las comisiones están escritas en los terminos y
                condiciones.
              </div>
            </li>
            <li class="prod-decs">
              <div class="decs-wrap decs-left">
                El sistema de verificación es súper eficiente, Para cada
                solicitud te dan la respuesta dentro de 1 hora.
              </div>
              <div class="prod-decs-img img-right prod-decs-img4"></div>
            </li>
          </ul>
        </li>
        <li id="faq" class="home-content-detail content-faq-wrap">
          <a name="faq"></a>
          <div class="content-detail content-faq">
            <div class="title">FAQ</div>
            <ul class="faq-lists">
              <li class="faq-list">
                <div class="icon-faq-wrap">
                  <div class="icon-faq icon-faq1"></div>
                </div>
                <div class="faq-desc">
                  <div class="faq-desc-title">Nuestras ventajas</div>
                  <div class="faq-desc-text">
                    <p>
                      <span class="faq-desc-pr">P:</span> Cuánto tiempo tarda el
                      registro?
                    </p>
                    <p>
                      <span class="faq-desc-pr">R:</span> Con celular android,
                      puedes terminar el registro en 1 solo minuto Aplicación.
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-list">
                <div class="icon-faq-wrap">
                  <div class="icon-faq icon-faq2"></div>
                </div>
                <div class="faq-desc">
                  <div class="faq-desc-title">Aplicación</div>
                  <div class="faq-desc-text">
                    <p><span class="faq-desc-pr">P:</span> Cómo usar?</p>
                    <p>
                      <span class="faq-desc-pr">R:</span>
                      Regístrate con tu celuar android y sube tu información
                      personal (ID, medio de ingreso y CURP).
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-list">
                <div class="icon-faq-wrap">
                  <div class="icon-faq icon-faq3"></div>
                </div>
                <div class="faq-desc">
                  <div class="faq-desc-title">Requerimiento</div>
                  <div class="faq-desc-text">
                    <p>
                      <span class="faq-desc-pr">P:</span> ¿Qué requisitos
                      necesitas para usar CaptarCash?
                    </p>
                    <p>
                      <span class="faq-desc-pr">R:</span>
                      Ser mexicano, mayor de 18 años.
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-list">
                <div class="icon-faq-wrap">
                  <div class="icon-faq icon-faq4"></div>
                </div>
                <div class="faq-desc">
                  <div class="faq-desc-title">Convenios</div>
                  <div class="faq-desc-text">
                    <p>
                      <span class="faq-desc-pr">P:</span> Cómo puedo obtener el
                      dinero?
                    </p>
                    <p>
                      <span class="faq-desc-pr">R:</span> Puedes elegir una
                      cuenta bancaria o directamente los locales para retirarlo
                      en efectivo.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li
          id="aboutUs"
          name="aboutUs"
          class="home-content-detail content-about-us-wrap"
        >
          <a name="aboutUs"></a>
          <div class="content-detail content-about-us">
            <div class="title">Sobre nosotros</div>
            <div class="about-us-detail">
              <div class="about-us-img">
                <div class="about-us-desc-wrap">
                  <div class="about-us-desc">
                    CaptarCash es una plataforma financiera que otorga / ofrece
                    préstamos en cualquier momento y cualquier lugar. Nuestro
                    servicio está basado mediante los estándares de seguridad de
                    internet.
                  </div>
                </div>
              </div>
              <div class="contact-us">
                <div class="contact">contáctanos</div>
                <br />
                <div class="email">captarcash@la-weshare.com</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="home-footer-wrap" id="header_footer">
      <div class="header-wrap">
        <span class="projectLogo"></span>
        <span class="project-name">CaptarCash</span>
        <ul class="navs-wrap">
          <li class="nav-wrap">
            <a href="#home" class="nav">Portal</a>
          </li>
          <li class="nav-wrap">
            <a href="#product" class="nav">Producto</a>
          </li>
          <li class="nav-wrap">
            <a href="#faq" class="nav">FAQ</a>
          </li>
          <li class="nav-wrap">
            <a href="#aboutUs" class="nav">Sobre nosotros</a>
          </li>
        </ul>
      </div>
    </div> -->
    <div class="home-footer-wrap">
      <div class="footer-wrap">
        <div class="footer-left">
          <div class="footer-img-wrap">
            <img src="./img/pic_map_footer.png" alt />
          </div>
        </div>
        <div class="footer-right">
          <div class="facebook-wrap">
            <div class="icon-facebook" @click="goToFacebook"></div>
            <p class="facebook-text">Facebook</p>
          </div>
          <div class="footer-company-name">Monmar Tecnología S.de R.L.</div>

          <div class="footer-company-tel">Teléfono: +52 5541609932</div>
          <div class="address">
            Direccion: paseo de la reforma 42 número int. 1ER piso OF.A colonia
            Juárez, delegación Cuauhtémoc, CDMX
          </div>
        </div>
        <div class="footer-center-border">
          <img src="./img/pic_fengexian.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css"; // //这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getStoreUuid, getUgid, getSessionId } from "@/utils/tool.ts";
import { dataAcq } from "@/utils/dataAcquisition.ts";

export default {
  name: "home",
  data() {
    return {
      prodSwiperOption: {
        autoplay: true,
        speed: 2000,
        pagination: {
          el: ".prod-pagination",
          paginationClickable: true,
        },
        preventClicksPropagation: true,
      },
      swiperOption: {
        autoplay: true,
        speed: 2000,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          paginationClickable: true,
        },
        preventClicksPropagation: true,
      },
      createdTime: new Date().getTime(),
      ACQdata: [
        {
          mid: "ACQ01",
          path: "/",
          referId: "phWebHome",
          pageId: "phWebHome",
          btnId: "",
          appid: "jk",
          ctime: this.createdTime,
          zuid: getStoreUuid(),
          swv: "ph_1.0.0.0",
          ugid: getUgid(),
          ch_biz: "jk",
          district: "ph",
          appver: "1.0.0",
          version: "1.0",
          tokenId: getUgid(),
          sessionId: getSessionId(),
          ch_sub: "2",
        },
      ],
    };
  },
  mounted() {
    dataAcq(this.ACQdata);
    this.$nextTick(() => {
      window.onscroll = function () {
        const headerMain = document.getElementById("header");
        if (window.pageYOffset >= 98) {
          headerMain.classList.remove("home-header-wrap");
          headerMain.classList.add("home-header-fix-wrap");
        } else {
          headerMain.classList.remove("home-header-fix-wrap");
          headerMain.classList.add("home-header-wrap");
        }
      };
    });
  },
  methods: {
    goToFacebook() {
      window.location.href = "https://www.facebook.com/CaptarCash/";
    },
    download() {
      // const url =
      //   "https://play.google.com/store/apps/details?id=id.captarcash.weshare.jiekuan";
      // const iframe = document.createElement("iframe");
      // iframe.src = url;
      // iframe.style.display = "none";
      // document.body.appendChild(iframe);
      const downloadUrl = 'https://s3u.captarcash.com/CaptarCash.apk'
      const downloadLink = document.createElement('a')
      downloadLink.setAttribute('download', true)
      downloadLink.setAttribute('href', downloadUrl)
      downloadLink.style.display = 'none'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      const data = [
        {
          mid: "ACQ03",
          eleId: "phWebHomedownloadApp",
          clickTime: new Date().getTime(),
          appid: "jk",
          ctime: new Date().getTime(),
          zuid: getStoreUuid(),
          swv: "ph_1.0.0.0",
          path: "/",
          ugid: getUgid(),
          ch_biz: "jk",
          district: "ph",
          appver: "1.0.0",
          version: "1.0",
          tokenId: getUgid(),
          sessionId: getSessionId(),
          ch_sub: "2",
        },
      ];
      dataAcq(data);
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="stylus">
@import '~@/css/var.styl';

.home.ignore {
  // font-family: PingFangSC-Medium;
  min-width: 1200px;

  .home-header-wrap {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 98px;
    line-height: 98px;
    transition: 1s;

    /* background: #eee; */
    .header-wrap {
      margin: 0 120px;

      .project-name {
        font-size: 26px;
        font-weight: 600;
        color: $navColor;
        font-family: PingFangSC-Semibold;
      }

      .navs-wrap {
        float: right;

        .nav-wrap {
          display: inline-block;
          margin-right: 43px;

          &:last-child {
            margin-right: 0;
          }

          .nav {
            color: $navColor;
            font-size: $navSize;
            font-weight: bold;
          }
        }
      }
    }
  }

  .home-header-fix-wrap {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    /* padding: 0 120px; */
    /* min-width: 1200px; */
    height: 98px;
    line-height: 98px;
    background: #fff;
    box-shadow: 0px 7px 11px 0px rgba(0, 0, 0, 0.1);
    transition: 1s;

    .header-wrap {
      margin: 0 120px;

      /* width: 100% */
      .project-name {
        font-size: 26px;
        font-weight: 600;
        color: #FF8900;
        font-family: PingFangSC-Semibold;
      }

      .navs-wrap {
        float: right;

        .nav-wrap {
          display: inline-block;
          margin-right: 43px;

          &:last-child {
            margin-right: 0;
          }

          .nav {
            color: #5B6C94;
            font-size: $navSize;
            font-weight: bold;

            &:hover {
              color: #32325C;
            }
          }
        }
      }
    }
  }

  .home-content-wrap {
    .download-wrap {
      position: relative;
      z-index: 100;
      margin: 0 auto;
      width: 1200px;

      /* height: 56px; */
      .download-btn-wrap {
        cursor: pointer;
        position: absolute;
        right: 0;
        z-index: 100;
        top: 634px;
        width: 240px;
        /* height: 56px; */
        border-radius: 50px;
        font-size: 20PX;
        height: 91px;
        width: 339px;
        .download-button {
          background: #fff;
          border: 0;
          outline: none;
          padding: 10px 30px;
          border-radius: 30px;
          box-shadow: 0 2px 10px -5px #FFDFA9;
          color: #f56505;
          font-size: 30px;
          cursor: pointer;
        }
      }
    }
    

    .home-img {
      position: relative;
      width: 100%;
      height: 920px;

      .download-wrap {
        position: relative;
        margin: 0 auto;
        width: 1200px;

        .download-btn-wrap {
          position: absolute;
          right: 0;
          top: 634px;
          width: 240px;
          height: 56px;
          background: #FFFFFF;
          border-radius: 50px;
          font-size: 0;

          .icon-download {
            margin: 4px 10px 0 25px;
            display: inline-block;
            vertical-align: top;
            width: 48px;
            height: 48px;
            background: url('./img/icon_logo.png') 100% center no-repeat;
          }

          .download-text {
            margin-top: 15px;
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #007FFF;
            line-height: 25px;
          }
        }
      }
    }

    .home-img1 {
      background: url('./img/pic_banner1.jpg') no-repeat;
      background-position: 50% 0;
    }

    .home-img2 {
      background: url('./img/pic_banner2.jpg') no-repeat;
      background-position: 50% 0;
    }

    .home-img3 {
      background: url('./img/pic_banner3.jpg') no-repeat;
      background-position: 50% 0;
    }

    .home-content-detail-wrap {
      .home-content-detail {
        .content-detail {
          padding: 120px 0;

          .title {
            text-align: center;
            font-size: 35px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            color: #32325C;
            line-height: 64px;
          }
        }
      }

      // 优势
      .content-our-advantage-wrap {
        margin-bottom: 120px;

        .content-our-advantage {
          position: relative;
          z-index: 1;
          margin: -120px auto 0;
          width: 1200px;
          box-shadow: 0px 10px 34px 0px rgba(210, 210, 210, 0.5);
          border-radius: 10px;
          background: #fff;

          .advantage-list {
            text-align: center;

            .advantage {
              margin-right: 148px;
              display: inline-block;
              vertical-align: top;

              &:last-child {
                margin-right: 0;
              }

              .advantage-detail-wrap {
                text-align: left;

                .advantage-icon-wrap {
                  margin-top: 95px;
                  width: 173px;
                  height: 169px;

                  .advantage-icon {
                  }

                  .advantage-icon1 {
                    width: 180px;
                    height: 180px;
                    background: url('./img/icon_goodat_01.png') 100% center no-repeat;
                  }

                  .advantage-icon2 {
                    width: 165px;
                    height: 158px;
                    background: url('./img/icon_goodat_02.png') 100% center no-repeat;
                  }

                  .advantage-icon3 {
                    width: 180px;
                    height: 180px;
                    background: url('./img/icon_goodat_03.png') 100% center no-repeat;
                  }
                }

                .advantage-detail {
                  margin-top: 76px;

                  .advantage-title {
                    margin-bottom: 10px;
                    font-size: 18px;
                    font-family: PingFangSC-Medium;
                    font-weight: bold;
                    color: #031D5B;
                    line-height: 25px;
                  }

                  .advantage-text-wrap {
                    width: 240px;

                    .advantage-text {
                      font-size: 16px;
                      font-family: PingFangSC-Medium;
                      font-weight: 500;
                      color: rgba(91, 108, 148, 1);
                      line-height: 32px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .content-show-swipper-wrap {
        width: 100%;
        height: 683px;
        background: url('./img/bg_phone5000.png') 100% no-repeat;
        background-position: 50% 0;

        .prod-wrap {
          .product {
            position: relative;
            width: 1200px;
            height: 684px;
            margin: 0 auto;

            .prod-desc {
              margin-top: 167px;
              display: inline-block;
              vertical-align: top;

              .prod-desc-title {
                width: 538px;
                font-size: 40px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #32325C;
                line-height: 64px;
              }

              .prod-desc-text-wrap {
                margin-top: 58px;
                width: 650px;

                .prod-desc-text {
                  margin-bottom: 10px;
                  font-size: 22px;
                  // font-family: PingFangSC-Medium;
                  font-weight: 500;
                  color: #5B6C94;
                  line-height: 32px;

                  &:last-child {
                    margin-bottom: 0;
                  }
                }

                .active-text {
                  font-size: 22px;
                  color: #32325C;
                }
              }
            }

            .prod-img {
              position: absolute;
              right: -10px;
              top: 90px;
              display: inline-block;
              vertical-align: top;
              width: 520px;
              height: 543px;
              background: #eee;
            }

            .prod-img1 {
              width: 520px;
              height: 543px;
              background: url('./img/phone1.png') 100% center no-repeat;
            }

            .prod-img2 {
              width: 518px;
              height: 543px;
              background: url('./img/phone2.png') 100% center no-repeat;
            }

            .prod-img3 {
              width: 518px;
              height: 543px;
              background: url('./img/phone3.png') 100% center no-repeat;
            }

            .prod-img4 {
              width: 518px;
              height: 543px;
              background: url('./img/phone4.png') 100% center no-repeat;
            }
          }
        }
      }

      /* 产品介绍 */
      .content-prod-decs-wrap {
        padding: 150px 0 120px;

        .content-prod-decs {
          margin: 0 auto;
          width: 1040px;

          .prod-decs {
            margin-bottom: 80px;

            &:last-child {
              margin-bottom: 0;
            }

            .prod-decs-img {
              display: inline-block;
              vertical-align: top;
              width: 380px;
              height: 380px;
              background: #eee;
            }

            .prod-decs-img1 {
              background: url('./img/pic_01.png') 100% center no-repeat;
            }

            .prod-decs-img2 {
              background: url('./img/pic_02.png') 100% center no-repeat;
            }

            .prod-decs-img3 {
              background: url('./img/pic_03.png') 100% center no-repeat;
            }

            .prod-decs-img4 {
              background: url('./img/pic_04.png') 100% center no-repeat;
            }

            .img-left {
              margin-right: 220px;
            }

            .img-right {
              margin-left: 220px;
            }

            .decs-wrap {
              margin-top: 76px;
              display: inline-block;
              vertical-align: top;
              width: 440px;
              font-size: 20px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: #32325C;
              line-height: 40px;
            }
          }
        }
      }

      // faq
      .content-faq-wrap {
        .content-faq {
          background: #FFF7ED;

          .faq-lists {
            margin-top: 90px;
            text-align: center;

            .faq-list {
              margin-right: 40px;
              display: inline-block;
              vertical-align: top;

              &:last-child {
                margin-right: 0;
              }

              .icon-faq-wrap {
                margin: 0 auto 30px;
                width: 60px;
                height: 60px;

                .icon-faq {
                  display: inline-block;
                }

                .icon-faq1 {
                  width: 60px;
                  height: 60px;
                  background: url('./img/icon_question_01.png') 100% center no-repeat;
                }

                .icon-faq2 {
                  width: 60px;
                  height: 60px;
                  background: url('./img/icon_question_02.png') 100% center no-repeat;
                }

                .icon-faq3 {
                  width: 60px;
                  height: 50px;
                  background: url('./img/icon_question_03.png') 100% center no-repeat;
                }

                .icon-faq4 {
                  width: 60px;
                  height: 60px;
                  background: url('./img/icon_question_04.png') 100% center no-repeat;
                }
              }

              .faq-desc {
                width: 270px;

                .faq-desc-title {
                  margin-bottom: 30px;
                  font-size: 18px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  color: #32325C;
                  line-height: 25px;
                }

                .faq-desc-text {
                  text-align: left;
                  font-size: 14px;
                  line-height: 28px;

                  p {
                    font-family: PingFangSC-Medium;
                    font-weight: bold;
                    color: #5B6C94;

                    .faq-desc-pr {
                      color: #FF9300;
                    }
                  }
                }
              }
            }
          }
        }
      }

      // 联系我们
      .content-about-us-wrap {
        .content-about-us {
          padding-bottom: 0;

          .about-us-detail {
            margin: 90px auto 0;
            width: 1200px;

            .about-us-img {
              position: relative;
              width: 1200px;
              height: 578px;
              background: url('./img/pic_aboutus.png') 100% center no-repeat;

              .about-us-desc-wrap {
                padding: 15px 0;
                width: 1200px;
                position: absolute;
                bottom: 0;
                background: rgba(0, 0, 0, 0.3);
                border-radius: 0px 0px 10px 10px;

                .about-us-desc {
                  margin: 0 auto;
                  width: 1021px;
                  font-size: 20px;
                  font-family: PingFangSC-Regular;
                  color: #FFFFFF;
                  line-height: 40px;
                }
              }
            }

            .contact-us {
              margin: 50px 0;
              text-align: center;

              .contact {
                display: inline-block;
                font-size: 20px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #32325C;
                line-height: 28px;
              }

              .email {
                display: inline-block;
                font-size: 20px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #32325C;
                line-height: 28px;
              }
            }
          }
        }
      }
    }
  }

  .home-footer-wrap {
    /* padding: 0 120px; */
    background: url('./img/bg_footer5000.png') no-repeat;
    // background-position: center;
    width: 100%;
    height: 266px;

    // height: 98px;
    .header-wrap {
      margin: 0 120px;
      height: 98px;
      line-height: 98px;

      .projectLogo {
        background: url('./img/project_logo.png') no-repeat;
        display: inline-block;
        width: 60px;
        height: 60px;
        position: relative;
        top: 17px;
      }

      .project-name {
        margin-left: 20px;
        font-size: 26px;
        font-weight: 600;
        color: $navColor;
        font-family: PingFangSC-Semibold;
      }

      .navs-wrap {
        float: right;

        .nav-wrap {
          display: inline-block;
          margin-right: 43px;

          &:last-child {
            margin-right: 0;
          }

          .nav {
            color: $navColor;
            font-size: $navSize;
            font-weight: bold;
          }
        }
      }
    }

    .footer-wrap {
      padding-top: 45px;
      width: 100%;
      // overflow: hidden;
      position: relative;

      >div {
        float: left;
        width: 50%;
      }

      .footer-left {
        overflow: hidden;

        .footer-img-wrap {
          float: right;
          margin-right: 80px;

          img {
            width: 290px;
            display: block;
          }
        }
      }

      .footer-right {
        padding-top: 5px;
        padding-left: 80px;
        box-sizing: border-box;

        .facebook-wrap {
          .icon-facebook {
            width: 60px;
            height: 60px;
            cursor: pointer;
            background: url('./img/icon_facebook.png') 100% center no-repeat;
          }

          .facebook-text {
            // text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #EDFFFB;
            line-height: 20px;
            cursor: pointer;
            margin-top: 5px;
          }
        }

        .footer-company-name {
          margin-top: 28px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;
        }

        .footer-company-tel {
          margin-top: 5px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;
        }

        .address {
          margin-top: 5px;
          font-size: 14px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #fff;
          line-height: 20px;
        }

        .privacyPolicy {
          margin-top: 10px;
          line-height: 20px;
          opacity: 0.7;

          a {
            color: #fff;
          }
        }
      }

      .footer-center-border {
        position: absolute;
        width: 3px;
        top: 12px;
        left: 50%;
        margin-left: -1.5px;

        img {
          display: block;
          height: 242px;
        }
      }
    }
  }

  .swiper-container {
    width: 100% !important;

    /* height: 684px !important; */
    .swiper-pagination-bullets {
      bottom: 160px;

      .swiper-pagination-bullet {
        width: 16px !important;
        height: 16px !important;
        margin: 0 10px;
      }
    }

    .swiper-pagination-bullet-active {
      background: #ff8900;
    }

    .swiper-pagination {
      margin: 0 !important;
      position: relative !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      width: 1200px !important;
      text-align: right !important;
    }

    .prod-pagination {
      margin: 0 auto !important;
      position: relative !important;
      top: -110px !important;
      width: 1200px !important;
    }
  }
}
</style>
